import React, { Fragment, useEffect } from "react";
import CreateProduct from "./CreateProduct.jsx";
import { useDispatch, useSelector } from "react-redux";
import { allCategoriesAction, allProductMarketsAction, allProductTypesAction, loadSettingsAction } from "../../redux/actions/userActions.js";
import Loader from "../loader/loader";




export const currencyOptions = [
  { option: "USD", value: "USD" },
];


const AddProdcuts = () => {


  const dispatch = useDispatch()


  useEffect(() => {
    const Headerlinkks = document.querySelectorAll(".headerLinks");
    const subLinks = document.querySelectorAll(".subLinks");
    const element = document.getElementById("products")
    const subElement = document.getElementById("add-product");

    Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
    subLinks.forEach(el => el.classList.remove("activeSubLink"));
    element?.classList.add("activeHeaderLink");
    subElement?.classList.add("activeSubLink");

    document.title = `Add Product`;
  }, []);

  const { loading: catLoading, categories } = useSelector(state => state.allCategories)

  const { loading: typeLoading, productTypes } = useSelector(state => state.allProductTypes);
  const { loading: marketLoading, productMarkets } = useSelector(state => state.allProductMarkets);
  const { loading: settingsLoading, settings } = useSelector(state => state.loadSettings)

  useEffect(() => {
    dispatch(allCategoriesAction())
    dispatch(allProductTypesAction())
    dispatch(allProductMarketsAction())
    dispatch(loadSettingsAction())
  }, [dispatch])

  const isLoading = catLoading || typeLoading || marketLoading || settingsLoading;

  return (
    <Fragment>
      <section className="p-[1.5vmax]">
        {isLoading ? (
          <Loader />
        ) : (
          <CreateProduct 
            categories={categories} 
            productTypes={productTypes} 
            settings={settings} 
            currencyOptions={currencyOptions} 
            productMarkets={productMarkets} 
          />
        )}
      </section>
    </Fragment>
  );
};


export default AddProdcuts;
